import { httpClient } from '@/services/http/httpClient'

export async function deleteIdea(id: string): Promise<void> {
  await httpClient.delete(`/ideas/ideas/${id}`)
}
